export default __webpack_public_path__ + "static/media/Group 6926.df03558b.svg";